import { useNavigate } from 'react-router-dom';
import { useMobileAuth } from '../../context/MobileAuthContext';
import MobileLayout from '../../components/mobile/MobileLayout';
import {
  Users,
  Truck,
  HardHat,
  Tag,
  Package,
  ChevronRight,
  ChevronLeft,
  ShieldCheck,
} from 'lucide-react';
import { Database, Settings } from 'lucide-react';

// Basic-tier mobile management hub — permission-gated per item.
const MobileManage = () => {
  const navigate = useNavigate();
  const { operator, can, isAdmin } = useMobileAuth();

  const MANAGE_ITEMS = [
    { icon: Users, label: 'Customers', desc: 'Customers & their sites', path: '/mobile/manage/customers', show: can('customers.read'), testId: 'manage-customers' },
    { icon: Truck, label: 'Equipment', desc: 'Manage assets', path: '/mobile/manage/equipment', show: can('equipment.read'), testId: 'manage-equipment' },
    { icon: HardHat, label: 'Operators', desc: 'Manage operators & workers', path: '/mobile/manage/operators', show: can('operators.read'), testId: 'manage-operators' },
    { icon: Tag, label: 'Worker Types', desc: 'Manage worker types', path: '/mobile/manage/worker-types', show: isAdmin(), testId: 'manage-worker-types' },
    { icon: Package, label: 'Suppliers', desc: 'Manage suppliers', path: '/mobile/manage/suppliers', show: can('suppliers.read'), testId: 'manage-suppliers' },
    { icon: Database, label: 'Data Management', desc: 'Asset types, pricing, materials & more', path: '/mobile/manage/data', show: isAdmin(), testId: 'manage-data' },
    { icon: Settings, label: 'Settings', desc: 'Organisation, users, billing & accounting', path: '/mobile/manage/settings', show: isAdmin() || can('billing.read') || can('accounting.read'), testId: 'manage-settings' },
  ];

  return (
    <MobileLayout>
      {/* Header */}
      <div className="bg-[var(--m-bg-card)] px-4 py-4 sticky top-0 z-10 safe-top">
        <div className="flex items-center gap-2">
          <button onClick={() => navigate('/mobile/dashboard')} className="p-1 -ml-1 text-[var(--m-text-secondary)] hover:text-[var(--m-text)]" data-testid="manage-back-btn">
            <ChevronLeft className="h-5 w-5" />
          </button>
          <ShieldCheck className="h-5 w-5 text-[#ffd108]" />
          <div>
            <h1 className="text-[var(--m-text)] font-bold text-lg" data-testid="manage-hub-title">Manage</h1>
            <p className="text-[var(--m-text-secondary)] text-xs">{operator?.company_name || 'Admin tools'}</p>
          </div>
        </div>
      </div>

      <div className="p-4 space-y-2" data-testid="manage-hub">
        <p className="text-[var(--m-text-secondary)] text-xs mb-2">
          Manage your operations from your phone.
        </p>

        {MANAGE_ITEMS.filter(item => item.show).map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className="w-full flex items-center gap-4 px-4 py-3.5 rounded-lg border border-[var(--m-border)] bg-[var(--m-bg-card)] transition-colors hover:bg-[var(--m-bg-elevated)] active:bg-[var(--m-bg-elevated)]"
              data-testid={item.testId}
            >
              <div className="w-9 h-9 rounded-lg bg-[var(--m-bg)] flex items-center justify-center shrink-0">
                <Icon className="h-5 w-5 text-[#ffd108]" />
              </div>
              <div className="flex-1 text-left">
                <div className="text-sm text-[var(--m-text)] font-medium">{item.label}</div>
                <div className="text-xs text-[var(--m-text-secondary)]">{item.desc}</div>
              </div>
              <ChevronRight className="h-4 w-4 text-[var(--m-text-muted)]" />
            </button>
          );
        })}
      </div>
    </MobileLayout>
  );
};

export default MobileManage;
